import { useSessionStore } from './SessionStore';
import { useState } from 'react';
import { useSiteSettings } from './context/SiteSettingsContext';




const SessionDetailsDev: React.FC = () => {
    const { sessionData, updateSession } = useSessionStore(); // ✅ updateSession importieren
    const [editedTitle, setEditedTitle] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
    const logLevel = siteSettings?.frontend_log_level ?? 0;

    if (!sessionData) return <p>Keine Sitzung ausgewählt</p>;

    // Funktion zum Speichern des geänderten Titels
    const handleSaveTitle = async () => {
        const success = await updateSession(sessionData.id, { name: editedTitle });
        if (success) {
            if (!isSiteSettingsLoading && logLevel >= 3) console.log('✅ Titel erfolgreich aktualisiert:', editedTitle);
            setIsEditing(false);
            setEditedTitle("");
        } else {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error('❌ Fehler beim Aktualisieren des Titels');
        }
    };

    return (
        <div>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {isEditing ? (
                    <input
                        type="text"
                        value={editedTitle}
                        onChange={(e) => setEditedTitle(e.target.value)}
                    />
                ) : (
                    <span>Title: {sessionData.name}</span>
                )}
                {isEditing ? (
                    <>
                        <button onClick={handleSaveTitle}>💾 Speichern</button>
                        <button onClick={() => {
                            setIsEditing(false);
                            setEditedTitle("");
                        }}>❌ Abbrechen</button>
                    </>
                ) : (
                    <button onClick={() => setIsEditing(true)} style={{ marginLeft: '10px' }}>✏️</button>
                )}
            </h2>
            <p>Datum: {new Date(sessionData.date).toLocaleDateString('de-DE', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            })}</p>
            <p>Dauer: {Math.round(Number(sessionData.length) / 60)} min</p>
            {sessionData.audio_file_name && <p>Audio: {sessionData.audio_file_name}</p>}
        </div>
    );
};

export default SessionDetailsDev;


